// extracted by mini-css-extract-plugin
module.exports = {"SuggestionsList":"SuggestionsList-2-Lvp","Title":"Title-33dF_"};